import type { CSSProperties } from 'react';
import { Toaster as SonnerToaster } from 'sonner';

import { useThemeMode } from '@/hooks/use-theme';

export function Toaster() {
  const { resolved } = useThemeMode();

  return (
    <SonnerToaster
      theme={resolved}
      position="bottom-right"
      closeButton
      gap={10}
      offset={20}
      style={{ '--width': 'min(356px, calc(100vw - 2rem))' } as CSSProperties}
      toastOptions={{
        classNames: {
          toast:
            'group !rounded-xl !border-border !bg-card/95 !text-card-foreground !shadow-[0_24px_70px_-24px_rgba(0,0,0,0.65)] !backdrop-blur-xl',
          title: '!text-[13px] !font-semibold',
          description: '!text-xs !text-muted-foreground',
          actionButton: '!rounded-lg !bg-primary !text-primary-foreground',
          closeButton: '!border-border !bg-card !text-muted-foreground',
        },
      }}
    />
  );
}
